import React from "react";
import SessionStore from "../../stores/SessionStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import {Redirect, Route} from "react-router-dom";
import PublicWrapper from "../wrappers/PublicWrapper";
import PropTypes from "prop-types";


const PublicOrRedirectRoute = ({component: Component, redirectRoute, appNavigator, ...rest}) => {
    class PublicRedirectWrapper extends React.Component {

        static propTypes = {
            usesDefaultFooter: PropTypes.bool.isRequired
        };

        static defaultProps = {
            usesDefaultFooter: true
        };

        constructor(props) {
            super(props);
            this.state = {
                "sessionState": SessionStore.getState()
            };
        }

        componentDidMount() {
            this.sessionStoreSubscriber =
                EventPublisher.subscribe(StoreUpdateEvents.SESSION_STORE_UPDATED, this.handleStoreUpdate);
        }

        componentWillUnmount() {
            EventPublisher.unsubscribe(this.sessionStoreSubscriber);
        }

        handleStoreUpdate = (topic, data) => {
            this.setState({
                "sessionState": SessionStore.getState()
            });
        };

        render() {
            if (this.state.sessionState.isAuthenticated()) {
                return (<Redirect to={redirectRoute}/>);
            }
            return (
                <PublicWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                    <Component appNavigator={appNavigator} {...this.props}/>
                </PublicWrapper>
            );
        }
    }
    return (<Route {...rest} render={(routeProps) => <PublicRedirectWrapper {...routeProps} {...rest}/>}/>);
};

export default PublicOrRedirectRoute;